<template>
  <div class="container">
    <div class="content">
      <div class="log-btn" @click="showLog" :class="{ 'log-disabled': !detail.audioIdPath }">
        <span v-if="!log.logStatus">留言和log</span>
        <span v-else>自动纪要</span>
      </div>
      <div class="title">
        <span>源码会议纪要</span>
        <img class="logo" src="../../assets/image/logo.png" />
      </div>

      <div v-if="+meetingType === 1" class="detail">
        <div class="row">
          <div class="detail-item">
            <span class="label">例会：</span>
            <span class="content">{{ detail.meetingName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">日期：</span>
            <span class="content">{{ detail.meetingDate }}</span>
          </div>
        </div>
        <div class="row">
          <div class="detail-item">
            <span class="label">项目：</span>
            <span class="content">{{ detail.projectName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">上会分类：</span>
            <span class="content">{{ detail.category }}</span>
          </div>
          <div class="detail-item">
            <span class="label">项目类型：</span>
            <span class="content">{{ detail.projectType }}</span>
          </div>
        </div>
        <div class="row">
          <div class="detail-item">
            <span class="label">轮次：</span>
            <span class="content">{{ detail.rounds }}</span>
          </div>
          <div class="detail-item">
            <span class="label">上会目的：</span>
            <span class="content">{{ detail.goal }}</span>
          </div>
          <div class="detail-item">
            <span class="label">项目组：</span>
            <span class="content">{{ detail.dealNames }}</span>
          </div>
        </div>
        <div class="row">
          <div class="detail-item">
            <span class="label">会议时间：</span>
            <span class="content">{{ detail.planTime }}</span>
          </div>
          <div class="detail-item">
            <span class="label">实际时长：</span>
            <span class="content">
              <span v-if="audio" class="content">{{ parseInt(audio.duration / 60) }}分钟</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="+meetingType === 2" class="detail">
        <div class="row">
          <div class="detail-item">
            <span class="label">例会：</span>
            <span class="content">{{ detail.meetingName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">日期：</span>
            <span class="content">{{ detail.meetingDate }}</span>
          </div>
        </div>
        <div class="row">
          <div class="detail-item">
            <span class="label">项目：</span>
            <span class="content">{{ detail.projectName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">实际时长：</span>
            <span class="content">
              <span v-if="audio" class="content">{{ parseInt(audio.duration / 60) }}分钟</span>
            </span>
          </div>
          <div class="detail-item">
            <span class="label">参与人：</span>
            <span class="content">{{ detail.dealNames }}</span>
          </div>
        </div>
        <div class="row">
          <div class="detail-item">
            <span class="label">讨论内容：</span>
            <span class="content">{{ detail.content }}</span>
          </div>
        </div>
      </div>
      <!-- 在最小宽度基础之上添加了滚动条 -->
      <div class="audio-container-wrap">
        <div class="audio-container" v-if="detail.audioId">
          <audio @ended="audioEnded" ref="audio" width="500px" :src="detail.audioIdPath"></audio>
          <div class="player">
            <div class="play-progress" v-if="audio">
              {{ moment((1596988800 + parseInt(audio.currentTime, 10)) * 1000).format('HH:mm:ss') }}/
              {{ moment((1596988800 + parseInt(audio.duration, 10)) * 1000).format('HH:mm:ss') }}
            </div>
            <div class="btn-group">
              <div
                v-if="tag.chooseTagIndex > -1 || summaryPoints.length"
                class="point-btn"
                :style="{ 'border-color': tag.chooseTagIndex == -1 ? 'red' : '#1890ff' }"
                @click="audioForward(-1, 'relative')"
              >
                <a-icon type="step-backward" style="font-size: 26px;" :style="{ color: tag.chooseTagIndex == -1 ? 'red' : '#1890ff' }" />
              </div>
              <div v-else class="point-btn-inactive">
                <a-icon type="step-backward" style="font-size: 26px; color: #cdcdcd;" />
              </div>
              <a-icon :type="playStatus ? 'pause-circle' : 'play-circle'" theme="twoTone" style="font-size: 46px;" two-tone-color="red" @click="audioPlay" />
              <div
                v-if="tag.chooseTagIndex > -1 || summaryPoints.length"
                class="point-btn"
                :style="{ 'border-color': tag.chooseTagIndex == -1 ? 'red' : '#1890ff' }"
                @click="audioForward(1, 'relative')"
              >
                <a-icon type="step-forward" style="font-size: 26px;" :style="{ color: tag.chooseTagIndex == -1 ? 'red' : '#1890ff' }" />
              </div>
              <div v-else class="point-btn-inactive">
                <a-icon type="step-forward" style="font-size: 26px; color: #cdcdcd;" />
              </div>
            </div>
            <div class="play-hint">
              <span v-if="tag.chooseTagIndex == -1">上一重点</span>
              <span v-else>上一标注</span>
              <span v-if="!playStatus">开始</span>
              <span v-else>暂停</span>
              <span v-if="tag.chooseTagIndex == -1">下一重点</span>
              <span v-else>下一标注</span>
            </div>
            <a-tooltip placement="top" overlayClassName="times-container">
              <template slot="title">
                <div class="items">
                  <div
                    class="item"
                    v-for="i in ['0.75', '1.0', '1.25', '1.5', '2.0']"
                    :key="i"
                    :class="{ 'item-active': i == playBackRate }"
                    @click="choosePlayBackRate(i)"
                  >
                    {{ i }}x
                  </div>
                </div>
              </template>
              <div class="times-btn">
                <span v-if="playBackRate == 1">倍速</span>
                <span v-else>{{ playBackRate }}x</span>
              </div>
            </a-tooltip>
          </div>
          <div class="timeline" ref="timeline" @click="chooseProgress">
            <div class="waveform"></div>
            <div class="waveform-active" :style="{ width: played.width }"></div>
            <div class="flag-container" v-if="playBar">
              <div v-for="(flag, index) in summaryPoints" :key="index" @click.stop="audioForward(index, 'absolute')">
                <a-icon
                  v-if="flag.show"
                  type="flag"
                  style="position: absolute; font-size: 14px;"
                  :style="{
                    left: flag.percentage * playBar.width + 'px',
                    color: flag.range.includes(currentSummaryIndex) ? 'rgba(255,0,0,1)' : 'rgba(255,0,0,0.3)'
                  }"
                ></a-icon>
                <div
                  v-if="flag.show"
                  style="border-radius:50%; border:1px solid; position: absolute; width: 14px; height: 14px; top: 14px; display: flex; align-items: center; justify-content: center"
                  :style="{
                    left: flag.percentage * playBar.width + 'px',
                    color: flag.range.includes(currentSummaryIndex) ? 'rgba(255,0,0,1)' : 'rgba(255,0,0,0.3)'
                  }"
                >
                  {{ flag.showStr }}
                </div>
              </div>
            </div>
            <div class="mark-large-container" v-for="item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]" :key="item">
              <div class="mark-large">
                <span v-if="item % 2 == 0">{{ timeMarkers[item / 2] }}</span>
              </div>
              <div class="mark-small" v-for="_item in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="_item"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="tag-container" v-if="!log.logStatus && paragraphs.length">
        <div
          class="tag-item"
          :class="{ 'tag-item-active': index == tag.chooseTagIndex }"
          v-for="(tagItem, index) in tags"
          :key="index"
          @click="matchWord(tagItem, index)"
          @mouseover="tag.tagOnIndex = index"
          @mouseleave="tag.tagOnIndex = -1"
        >
          <span>{{ tagItem.tag }}</span>
          <div class="close-btn" v-if="tag.tagOnIndex == index && tagItem.type == 1" @click.stop="deleteTag(index)">
            <a-icon type="close-circle" style="color:#ed0008; font-size: 16px" />
          </div>
        </div>
        <div class="tag-item" style="font-size:20px; width:30px;" @click="addTag">+</div>
      </div>
      <div class="text-container" v-if="!log.logStatus && detail.audioId && paragraphs.length">
        <div class="audio-text" :class="{ 'text-container-edit': originEditStatus, 'text-container-half': summaryShowStatus }">
          <div class="paragraph-des">共计{{ textCount }}个字，最后一次修改时间：{{ updateAt }}</div>
          <div class="paragraph" v-for="(paragraph, p_index) in paragraphs" :key="p_index">
            <div
              v-for="(item, s_index) in paragraph.sentences"
              :key="s_index"
              class="sentence"
              :class="{ playing: item.id == playingIndex }"
              @click="chooseSentence(p_index, s_index)"
              :ref="item.id == centerSentenceIndex ? 'activeRef' : ''"
            >
              <span v-if="s_index == 0" :style="{ color: speakerColor[item.speaker - 1] }">讲话人{{ item.speaker }}：</span>
              <div
                class="sentence-content"
                :class="{ 'sentence-content-editing': originEditStatus }"
                v-html="item.text + '&nbsp'"
                :contenteditable="originEditStatus"
                @input="editOriginContent($event, item)"
              ></div>
            </div>
          </div>
        </div>
        <!-- 会议纪要 start / 用于人工重点匹配 / 内容为会议的[上会讨论记录]-->
        <div
          ref="summary"
          class="summary-text text-container-half"
          :class="{ 'text-container-edit': summaryEditStatus }"
          v-if="summaryShowStatus"
          data-order="-1"
          v-html="summary"
          @click="chooseSummary"
          :contenteditable="summaryEditStatus"
        ></div>
        <!-- 会议纪要 end -->
      </div>
      <div class="noaudio" v-if="!detail.audioId && !log.logStatus">
        请点击右侧【上传录音】将例会录音文件上传
        <br />可接受格式包括m4a
      </div>
      <div class="waitingconvert" v-if="detail.audioId && !paragraphs.length && !log.logStatus">
        <p>源码AI正在将录音转换为文字纪要，需要点时间，请稍后查看</p>
        <div class="convert-background">
          <img src="/common/convertingAudio.png" />
        </div>
      </div>

      <div class="log-container" v-if="log.logStatus">
        <div class="new-log" v-if="log.editingIndex == -1">
          <a-textarea placeholder="发布留言/评论" :auto-size="{ minRows: 3, maxRows: 6 }" v-model="log.logContent"></a-textarea>
          <div class="save-btn" @click="manageLog(1)">保存</div>
        </div>
        <div class="log-list">
          <div v-for="(logItem, index) in log.logList" :key="index" class="log-item">
            <div class="description">
              <div class="headimg">
                <img :src="logItem.avatar" />
                <span class="nickname">{{ logItem.nickname }}</span>
              </div>
              <div class="updatetime">{{ logItem.updateAt }}</div>
            </div>
            <div class="log-content" v-if="log.editingIndex != index">{{ logItem.content }}</div>
            <a-textarea
              style="margin-top: 10px;"
              v-if="log.editingIndex == index"
              :auto-size="{ minRows: 3, maxRows: 6 }"
              v-model="log.logContent"
            ></a-textarea>
            <div class="log-operation" v-if="logItem.canOperate">
              <span @click="clickLogEdit(index, logItem)" v-if="log.editingIndex != index" style="margin-right: 10px;">
                <iconfont icon-class="edit" iconSize="12" iconColor="000" />编辑
              </span>
              <span class="log-save" @click="manageLog(2, logItem)" v-if="log.editingIndex == index">保存</span>
              <span @click="manageLog(3, logItem)" v-if="log.editingIndex != index"> <iconfont icon-class="del" iconSize="12" iconColor="000" />删除 </span>
            </div>
          </div>
        </div>
      </div>

      <div class="menu">
        <div class="audio-menu">
          <a-upload
            v-show="+meetingType === 1"
            name="file"
            class="operation"
            :headers="headers"
            :action="uploadAudioAction"
            :data="{ meetingProjectId: meetingProjectId, duration: uploadDuration }"
            :showUploadList="false"
            @change="audioUploadChange"
            :before-upload="audioBeforeUpload"
          >
            <a-icon type="upload" />
            <span>上传录音</span>
          </a-upload>
          <div class="operation" :class="{ 'operation-disabled': !detail.audioId || !paragraphs.length }" @click="reproduce">
            <a-icon type="retweet" />生成纪要
          </div>
        </div>
        <div class="text-menu">
          <div class="operation" @click="editOrSave" :class="{ 'operation-disabled': !paragraphs.length }">
            <span v-if="originEditStatus"> <a-icon type="save" />保存纪要 </span>
            <span v-else> <a-icon type="edit" />编辑纪要 </span>
          </div>
          <div class="operation" :class="{ 'operation-disabled': !summary }" @click="summaryShow">
            <a-icon v-if="!summaryShowStatus" type="menu-fold" />
            <a-icon v-else type="menu-unfold" />人工重点
          </div>
          <div class="operation" :class="{ 'operation-disabled': matchStatus == 0 }" @click="autoMatch">
            <span v-if="matchStatus == 0"> <a-icon type="swap" />匹配中 </span>
            <span v-else> <a-icon type="swap" />自动匹配 </span>
          </div>
          <!-- <div
            class="operation"
            :class="{ 'operation-disabled': !summaryShowStatus }"
            @click="summaryEditOrSave"
          >
            <span v-if="summaryEditStatus">保存纪要</span>
            <span v-else>编辑纪要</span>
          </div>-->
        </div>
      </div>

      <div class="play-menu" v-if="paragraphs.length">
        <a-tooltip placement="top">
          <template slot="title">
            <span>回到顶部</span>
          </template>
          <div class="operation" @click="toTop(1)" v-if="!log.logStatus">
            <a-icon type="up-circle" />
          </div>
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <span>回到当前</span>
          </template>
          <div class="operation" @click="toTop(0)" v-if="!log.logStatus">
            <a-icon type="redo" />
          </div>
        </a-tooltip>

        <a-tooltip placement="top">
          <template slot="title">
            <span>回到底部</span>
          </template>
          <div class="operation" @click="toTop(-1)" v-if="!log.logStatus">
            <a-icon type="down-circle" />
          </div>
        </a-tooltip>
      </div>
      <a-progress
        v-if="uploadProgress"
        :width="40"
        style="position:absolute; z-index: 100; top: 40vh; left: 50%; transform: translateX(-50%);"
        type="circle"
        :percent="uploadProgress"
      />
      <a-spin
        v-if="audioUploading"
        :width="40"
        style="position:absolute; z-index: 100; top: 40vh; left: 50%; transform: translateX(-50%);"
        tip="当前会议有一个录音正在处理中，请稍后刷新..."
      />
      <a-modal v-model="tagModalVisible" title="增加tag" @ok="submitTag">
        <a-input v-model="tagToAdd" />
      </a-modal>
      <a-modal v-model="tagModalVisible" title="增加tag" @ok="submitTag">
        <a-input v-model="tagToAdd" />
      </a-modal>
      <a-modal :visible="confirmGoOn" @ok="triggerConfirmGoOn(true)" @cancel="triggerConfirmGoOn(false)">
        <p style="color: red">{{ confirmGoOn }}</p>
      </a-modal>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import {
  audioTagEdit,
  audioMeetingDetail,
  audioLogQuery,
  audioLogManage,
  audioMeetingContent,
  audioContentModify,
  getSummaryPoints,
  autoMatch,
  reproduceAudioContent,
  queryUploadStatus
} from '@/api/project';
import { getCompanyNoteDetail, editCompanyNotes } from '@/api/work';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      moment,
      detail: {},
      matchStatus: 0,
      speakerColor: ['blue', 'green', 'orange', 'red'],
      paragraphs: [],
      textCount: 0,
      updateAt: null,
      tags: [],
      audio: { currentTime: 0 }, //audio dom元素
      audioUploading: false,
      playBackRate: 1,
      uploadProgress: false,
      confirmGoOn: false,
      uploadDuration: null,
      playBar: null,
      centerSentenceIndex: -1, //居于屏幕中央的
      playingIndex: -1,
      playingItem: null,
      playStatus: false, //播放状态
      currentTime: 0,
      log: {
        editingIndex: -1,
        logStatus: false, //显示log还是显示内容
        logContent: '',
        logList: []
      },
      originEditStatus: false, //编辑状态
      note: null,
      summary: '',
      summaryEditStatus: false, //编辑状态
      summaryShowStatus: false, //人工纪要是否显示
      summaryPoints: [],
      currentSummaryIndex: -1,
      currentSummaryDoms: [],
      tag: {
        matchedWordsIndexes: [],
        chooseTagIndex: -1,
        tagCursor: -1, //进行到该tag的第几个匹配
        tagOnIndex: -1 //浮于哪个tag
      },
      originEditGroup: {},
      timer: null,
      played: {
        time: 0,
        width: 0
      },
      timeMarkers: [],
      tagModalVisible: false,
      tagToAdd: null,
      meetingProjectId: this.$route.query.meetingProjectId,
      meetingType: this.$route.query.meetingType,
      uploadAudioAction: process.env.VUE_APP_BASE_API + '/upload/uploadMeetingProjectAudio',
      time: 0
    };
  },
  computed: {
    ...mapGetters(['token']),
    headers() {
      return { Authorization: this.token };
    }
  },
  watch: {
    centerSentenceIndex: {
      handler: function() {
        this.$nextTick(() => {
          if (this.$refs.activeRef && this.$refs.activeRef[0]) {
            this.$refs.activeRef[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          }
        });
      },
      immediate: true
    },
    playStatus(newVal) {
      if (newVal) {
        this.chooseTime();
      }
    }
  },
  created() {
    queryUploadStatus({
      meetingProjectId: this.meetingProjectId
    }).then(res => {
      this.audioUploading = !res.data.status;
    });
  },
  mounted() {
    this.init();
    window.addEventListener('resize', timelineRefresh);
    let _this = this;
    function timelineRefresh() {
      _this.playBar = _this.$refs.timeline.getBoundingClientRect();
      _this.played.width = `${parseInt((_this.audio.currentTime / _this.audio.duration) * _this.playBar.width)}px`;
    }
  },
  methods: {
    async init() {
      await audioMeetingDetail({ meetingProjectId: this.meetingProjectId, meetingType: this.meetingType }).then(res => {
        this.detail = res.data;
        // this.detail.audioIdPath = this.detail.audioIdPath.replace("https://hubble.sourcecodecap.com/prod-api/", "http://127.0.0.1:8081/hubble-back/")
        this.detail.audioIdPath = this.detail.audioIdPath ? `${this.detail.audioIdPath}?Authorization=${this.token}` : null;
      });
      if (this.detail.audioId) {
        this.audio = this.$refs.audio;
        this.playBar = this.$refs.timeline.getBoundingClientRect();
        this.audio.oncanplay = () => {
          const duration = this.audio.duration;
          for (let i = 0; i < 10; i++) {
            const seconds = (duration * i) / 10;
            const day = moment.duration(seconds, 'seconds');
            const mins = Math.floor(day.asMinutes());
            const sec = Math.floor(day.asSeconds()) - mins * 60;
            this.timeMarkers.push(`${mins < 10 ? '0' + mins : mins}:${sec < 10 ? '0' + sec : sec}`);
          }
          // TODO
          getSummaryPoints({
            id: this.detail.audioId
          }).then(res => {
            if (res.code === 200) {
              this.matchStatus = res.data.status;
              res.data.list.sort((a, b) => {
                return parseFloat(a.start, 10) - parseFloat(b.start, 10);
              });
              this.summaryPoints = res.data.list.map((item, index, array) => {
                item.percentage = item.start / this.audio.duration;
                item.show = true;
                item.range = [];
                if (index > 0 && Math.abs(array[index - 1].percentage - item.percentage) < 0.008) {
                  array[index - 1].show = false;
                  item.range.push(index);
                  item.range = item.range.concat(array[index - 1].range);
                  item.showStr = 'N';
                } else {
                  item.showStr = index + 1;
                  item.range.push(index);
                }
                return item;
              });
            }
          });
        };
        audioMeetingContent({ id: this.detail.audioId }).then(res => {
          if (res.code === 200) {
            this.updateAt = res.data.updateAt;
            this.textCount = res.data.textCount;
            this.paragraphs = res.data.paragraphs.map(item => {
              return {
                sentences: item
              };
            });
            this.tags = res.data.tags
              .sort((a, b) => {
                a.type - b.type;
              })
              .slice(0, 19);
          }
        });
        if (+this.meetingType === 1) {
          getCompanyNoteDetail(
            {
              // workProgressId: 1000,
              // type: 1
              type: 2,
              meetingProjectId: this.meetingProjectId
            },
            false
          ).then(res => {
            if (res.code === 200) {
              this.summary = res.data.content;
              this.note = res.data;
              // this.summary = `
              // <p data-order=0>
              //   20200506 interesting case&nbsp;
              // </p>
              // <p data-order=1>
              //   YT：主要分享一下小家电这波，对应日本市场来看的话，经济下行时期小家电会有Booming的机会，但是目前看起来这个机会还是相对分散的，需要bet的机会有两条路径，一是直面美苏九，类似九阳崛起的路径，做产品升级，但是产品壁垒很难建立，二是不断扩品类，做长尾，类小熊电器。
              // </p>
              // <p>
              //   YW：低糖电饭煲没有讲堂的科学性，<span data-order=2>是不是品类没机会了，接下来还能</span>赌什么品类。
              // </p>`
            }
          });
        }
      }
    },
    audioUploadChange(data) {
      if (data.event) {
        this.uploadProgress = parseInt((data.event.loaded / data.event.total) * 100, 10);
        if (this.uploadProgress >= 100) {
          this.uploadProgress = false;
          this.audioUploading = true;
        }
      }
      if (data.file.response) {
        if (data.file.response.code === 200) {
          this.uploadProgress = false;
          this.audioUploading = false;
          this.$message.success('上传成功');
          const resp = data.file.response.data;
          this.detail.audioId = resp.fileId;
          this.detail.audioIdPath = resp.fileIdPath;
          this.paragraphs = [];
        } else {
          this.uploadProgress = false;
          this.$message.error(data.file.response.msg);
        }
      }
    },
    triggerConfirmGoOn(signal) {
      window.dispatchEvent(new CustomEvent('confirmGoOnEvent', { detail: signal }));
      this.confirmGoOn = false;
    },
    audioBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        new Promise((resolve, reject) => {
          const fileNameArr = file.name.split('.');
          if (this.audioUploading) {
            this.$message.error('有一个录音正在服务端处理（可以稍后刷新重试），请不要重复上传');
            reject();
          } else if (fileNameArr[fileNameArr.length - 1] !== 'm4a') {
            this.$message.error('请上传m4a格式文件');
            reject();
          } else if (!this.detail.audioId) {
            resolve();
          } else {
            this.confirmGoOn = '已有录音，是否重新上传（覆盖录音需要重新生成文字）';
            this.confirmGoOnFunction = e => {
              if (e.detail) {
                resolve();
              } else {
                reject();
              }
              window.removeEventListener('confirmGoOnEvent', this.confirmGoOnFunction);
            };
            window.addEventListener('confirmGoOnEvent', this.confirmGoOnFunction);
          }
        })
          .then(() => {
            const url = URL.createObjectURL(file);
            const audioElement = new Audio(url);
            let duration;
            this.loadedmetadataFunction = () => {
              duration = audioElement.duration;
              if (duration >= 3 * 60 * 60) {
                this.$message.error('音频时间不能超过180min');
                reject();
              } else {
                this.uploadDuration = parseInt(duration, 10);
                resolve(duration);
                this.uploadProgress = true;
              }
              audioElement.removeEventListener('loadedmetadata', this.loadedmetadataFunction);
            };
            audioElement.addEventListener('loadedmetadata', this.loadedmetadataFunction);
          })
          .catch(() => {
            reject();
          });
      });
    },
    choosePlayBackRate(speed) {
      this.audio.playbackRate = speed;
      this.playBackRate = speed;
    },
    audioPlay() {
      if (this.playStatus) {
        this.playStatus = false;
        this.audio.pause();
      } else {
        this.playStatus = true;
        this.audio.play();
      }
    },
    audioEnded() {
      this.playStatus = false;
    },
    audioForward(forward, type) {
      if (this.tag.chooseTagIndex > -1 && type !== 'absolute') {
        this.tagNextMatch(forward);
      } else {
        if (type === 'relative') {
          this.currentSummaryIndex = (this.currentSummaryIndex + forward + this.summaryPoints.length) % this.summaryPoints.length;
        } else if (type === 'absolute') {
          this.currentSummaryIndex = forward;
          if (this.tag.chooseTagIndex > -1) {
            this.tag.chooseTagIndex = -1;
            this.tag.matchedWordsIndexes.forEach(item => {
              const sentence = this.paragraphs[item.pIndex].sentences[item.sIndex];
              sentence.text = sentence.text.replace(/<\/*span[^]*?>/g, '');
            });
          }
        }
        this.currentSummaryDoms.forEach(dom => {
          dom.style.color = 'rgba(0,0,0,0.6)';
        });
        const summaryItemDoms = document.querySelectorAll(`*[data-order='${this.summaryPoints[this.currentSummaryIndex].order}']`);
        this.currentSummaryDoms = [];
        for (let _i = 0; _i < summaryItemDoms.length; _i++) {
          this.currentSummaryDoms.push(summaryItemDoms[_i]);
          summaryItemDoms[_i].style.color = 'red';
          if (_i === 0) {
            summaryItemDoms[_i].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
          }
        }
        this.$nextTick(() => {
          this.choosePoint();
        });
      }
    },
    chooseSentence(p_index, s_index) {
      if (!this.originEditStatus) {
        const item = this.paragraphs[p_index].sentences[s_index];
        this.playingItem = item;
        if (+this.tag.chooseTagIndex === -1) {
          this.playingIndex = this.centerSentenceIndex = item.id;
        } else {
          this.playingIndex = this.centerSentenceIndex = item.id;
        }
        this.audio.currentTime = parseFloat(item['start'], 10);
        this.playBar = this.$refs.timeline.getBoundingClientRect();
        this.played.width = `${parseInt((this.audio.currentTime / this.audio.duration) * this.playBar.width)}px`;
        this.playStatus = true;
        this.audio.play();
      }
    },
    chooseProgress(e) {
      this.playBar = this.$refs.timeline.getBoundingClientRect();
      const bar = this.playBar;
      const X = e.x;
      const progress = (X - bar.x) / bar.width;
      this.played.time = this.audio.duration * progress;
      this.played.width = `${parseInt(bar.width * progress, 10)}px`;
      this.audio.currentTime = this.audio.duration * progress;
      this.playStatus = true;
      this.audio.play();
    },
    timeSearchSentence(time) {
      let stop = false;
      if (this.paragraphs && this.paragraphs.length) {
        this.paragraphs.forEach(paragraph => {
          if (stop) return;
          paragraph.sentences.forEach(sentence => {
            if (stop) return;
            const start = parseFloat(sentence['start'], 10);
            const end = parseFloat(sentence['end'], 10);
            if ((start <= time && end >= time) || (start >= time && end >= time)) {
              //start >= time && end >= time因为句子间有空隙
              if (+this.tag.chooseTagIndex === -1 && !this.originEditStatus) {
                this.playingIndex = this.centerSentenceIndex = sentence.id;
              } else {
                this.playingIndex = this.centerSentenceIndex = sentence.id;
              }
              this.playBar = this.$refs.timeline.getBoundingClientRect();
              this.played.width = `${parseInt((this.audio.currentTime / this.audio.duration) * this.playBar.width)}px`;
              stop = true;
            }
          });
        });
      } else {
        this.playBar = this.$refs.timeline.getBoundingClientRect();
        this.played.width = `${parseInt((this.audio.currentTime / this.audio.duration) * this.playBar.width)}px`;
      }
    },
    chooseTime() {
      const time = this.audio.currentTime;
      this.timeSearchSentence(time);
      this.timer = setTimeout(() => {
        if (this.playStatus) {
          this.chooseTime();
        }
      }, 500);
    },
    choosePoint() {
      this.audio.currentTime = this.summaryPoints[this.currentSummaryIndex].start;
      this.playStatus = true;
      this.audio.play();
      this.chooseTime();
    },
    matchWord(item, index) {
      const word = item.tag.replace(/（[0-9]*?）/, '');
      this.tag.matchedWordsIndexes.forEach(item => {
        const sentence = this.paragraphs[item.pIndex].sentences[item.sIndex];
        sentence.text = sentence.text.replace(/<\/*span[^]*?>/g, '');
      });
      this.tag.tagCursor = -1;
      if (+index === +this.tag.chooseTagIndex) {
        this.tag.chooseTagIndex = -1;
      } else {
        this.tag.chooseTagIndex = index;
        this.tag.matchedWordsIndexes = [];
        this.paragraphs.forEach((paragraph, pIndex) => {
          paragraph.sentences.forEach((sentence, sIndex) => {
            if (sentence.text.indexOf(word) > -1) {
              sentence.text = sentence.text.replace(new RegExp(word, 'g'), `<span style='background: #1890f7; color: white;'>${word}</span>`);
              this.tag.matchedWordsIndexes.push({
                id: sentence.id,
                pIndex: pIndex,
                sIndex: sIndex
              });
            }
          });
        });
      }
    },
    tagNextMatch(forward) {
      const len = this.tag.matchedWordsIndexes.length;
      let targetItem;
      if (!this.playingItem) {
        this.tag.tagCursor = 0;
        const indexItem = this.tag.matchedWordsIndexes[this.tag.tagCursor];
        targetItem = this.paragraphs[indexItem.pIndex].sentences[indexItem.sIndex];
      } else if (+this.tag.tagCursor === -1 || this.tag.matchedWordsIndexes.map(item => +item.id).indexOf(this.playingItem.id) === -1) {
        let diffArray = [];
        this.tag.matchedWordsIndexes.forEach((item, index) => {
          const pIndex = item.pIndex;
          const sIndex = item.sIndex;
          const sentence = this.paragraphs[pIndex].sentences[sIndex];
          diffArray.push({
            pIndex: pIndex,
            sIndex: sIndex,
            diff: this.playingItem.start - sentence.start,
            index: index
          });
        });
        let targetDiff;
        if (+forward === 1) {
          if (diffArray[diffArray.length - 1].diff > 0) {
            targetDiff = diffArray[0];
          } else {
            targetDiff = diffArray.filter(diff => diff.diff <= 0).sort((a, b) => b.diff - a.diff)[0];
          }
        } else if (+forward === -1) {
          if (diffArray[0].diff < 0) {
            targetDiff = diffArray[diffArray.length - 1];
          } else {
            targetDiff = diffArray.filter(diff => diff.diff >= 0).sort((a, b) => a.diff - b.diff)[0];
          }
        }
        this.tag.tagCursor = targetDiff.index;
        targetItem = this.paragraphs[targetDiff.pIndex].sentences[targetDiff.sIndex];
      } else {
        this.tag.tagCursor = (this.tag.tagCursor + forward + len) % len;
        const indexItem = this.tag.matchedWordsIndexes[this.tag.tagCursor];
        targetItem = this.paragraphs[indexItem.pIndex].sentences[indexItem.sIndex];
      }
      this.playingItem = targetItem;
      this.playingIndex = this.centerSentenceIndex = targetItem.id;
      this.audio.currentTime = targetItem.start;
    },
    editOrSave() {
      this.originEditOrSave();
      if (this.summaryShowStatus) {
        this.summaryEditOrSave();
      }
    },
    originEditOrSave() {
      if (this.paragraphs.length) {
        this.originEditStatus = !this.originEditStatus;
        if (!this.originEditStatus) {
          audioContentModify({
            id: this.detail.audioId,
            contents: this.originEditGroup
          }).then(res => {
            if (res.code === 200) {
              this.tags = this.tags
                .sort((a, b) => {
                  a.type - b.type;
                })
                .slice(0, 19);
              this.$message.success('录音文字保存成功');
            }
          });
        }
      }
    },
    summaryEditOrSave() {
      if (this.summaryShowStatus) {
        this.summaryEditStatus = !this.summaryEditStatus;
        if (!this.summaryEditStatus) {
          let editedSummary = this.$refs.summary.innerHTML;
          editedSummary = editedSummary.replace(/<[^]*?>/g, '');
          if (this.summary.replace(/<[^]*?>/g, '') !== editedSummary) {
            this.summary = this.$refs.summary.innerHTML;
            editCompanyNotes({
              id: this.note.id,
              companyId: this.note.companyId,
              content: this.summary.replace(/style="[^]*?"/g, ''),
              execDate: moment(new Date(), 'YYYY-MM-DD'),
              fileIds: this.note.companyFiles
                ? this.note.companyFiles
                  .map(item => {
                    return item.id;
                  })
                  .join(',')
                : [],
              notesTagIds: this.note.tags
                ? this.note.tags
                  .map(item => {
                    return item.id;
                  })
                  .join(',')
                : [],
              ownerUserIds: this.note.owners
                ? this.note.owners
                  .map(item => {
                    return item.id;
                  })
                  .join(',')
                : [],
              notifyUserIds: this.note.notifyUsers
                ? this.note.notifyUsers
                  .map(item => {
                    return item.id;
                  })
                  .join(',')
                : []
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('纪要保存成功');
              }
            });
          }
        }
      }
    },
    summaryShow() {
      if (this.summary) {
        this.summaryShowStatus = !this.summaryShowStatus;
        if (this.summaryShowStatus) {
          this.$nextTick(() => {
            this.summaryPoints.forEach(summary => {
              const doms = document.querySelectorAll(`*[data-order='${summary.order}']`);
              if (doms.length > 0) {
                for (let _i = 0; _i < doms.length; _i++) {
                  doms[_i].style.background = 'rgba(0,0,0,0.1)';
                }
              }
            });
            if (+this.currentSummaryIndex !== -1) {
              const summaryItemDoms = document.querySelectorAll(`*[data-order='${this.summaryPoints[this.currentSummaryIndex].order}']`);
              this.currentSummaryDoms.forEach(dom => {
                dom.style.color = 'rgba(0,0,0,0.6)';
              });
              for (let _i = 0; _i < summaryItemDoms.length; _i++) {
                const summaryItemDom = summaryItemDoms[_i];
                summaryItemDom.style.color = 'red';
                summaryItemDom.scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
                this.currentSummaryDoms.push(summaryItemDom);
              }
            }
          });
        }
        if (this.originEditStatus) {
          this.summaryEditOrSave();
        }
        this.$nextTick(() => {
          if (this.$refs.activeRef && this.$refs.activeRef[0]) {
            this.$refs.activeRef[0].scrollIntoView({ behavior: 'auto', block: 'center', inline: 'nearest' });
          }
        });
      }
    },
    chooseSummary(e) {
      if (!this.summaryEditStatus && this.summaryPoints.length > 0) {
        if (this.currentSummaryDoms.length > 0) {
          this.currentSummaryDoms.forEach(dom => {
            dom.style.color = 'rgba(0,0,0,0.6)';
          });
        }
        this.currentSummaryDoms = [];
        let dom = e.target;
        let dataOrder = dom.getAttribute('data-order');
        while (!dataOrder || +dataOrder !== -1) {
          if (!dataOrder) {
            dom = dom.parentNode;
            dataOrder = dom.getAttribute('data-order');
          } else {
            break;
          }
        }
        if (+dataOrder !== -1) {
          this.currentSummaryDoms = [dom];
          dom.style.color = 'red';
          this.summaryPoints.find((item, index) => {
            if (+item.order === +dataOrder) {
              this.currentSummaryIndex = index;
              return true;
            }
          });
          this.choosePoint();
        }
      }
    },
    editOriginContent(e, item) {
      const content = e.target.innerHTML;
      this.originEditGroup[item.id] = content.replace(/(.*)&nbsp;/, '$1');
    },
    addTag() {
      this.tagModalVisible = true;
    },
    deleteTag(index) {
      audioTagEdit({
        id: this.detail.audioId,
        type: 2,
        tag: this.tags[index].tag
      }).then(res => {
        if (res.code === 200) {
          this.tags.splice(index, 1);
        }
      });
    },
    submitTag() {
      if (this.tags.filter(tag => +tag.type === 1).length >= 19) {
        // TODO tag数量
        this.$message.error('用户添加的tag数量超出上限（20个）');
      }
      audioTagEdit({
        id: this.detail.audioId,
        type: 1,
        tag: this.tagToAdd
      }).then(res => {
        this.tagModalVisible = false;
        if (res.code === 200) {
          this.tags.unshift({ tag: this.tagToAdd, type: 1 });
          this.tags = this.tags.slice(0, 19);
        }
        this.tagToAdd = '';
      });
    },
    reproduce() {
      if (this.detail.audioId && this.paragraphs.length) {
        new Promise((resolve, reject) => {
          this.confirmGoOn = '重新生成纪要会覆盖您对纪要内容的修改，是否继续？';
          this.confirmGoOnFunction = e => {
            if (e.detail) {
              resolve();
            } else {
              reject();
            }
            window.removeEventListener('confirmGoOnEvent', this.confirmGoOnFunction);
          };
          window.addEventListener('confirmGoOnEvent', this.confirmGoOnFunction);
        })
          .then(() => {
            reproduceAudioContent({
              id: this.detail.audioId
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('生成成功');
                audioMeetingContent({ id: this.detail.audioId }).then(res => {
                  if (res.code === 200) {
                    this.paragraphs = res.data.paragraphs.map(item => {
                      return {
                        sentences: item
                      };
                    });
                    this.tags = res.data.tags
                      .sort((a, b) => {
                        a.type - b.type;
                      })
                      .slice(0, 19);
                  }
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    autoMatch() {
      if (+this.matchStatus === 1) {
        new Promise((resolve, reject) => {
          this.confirmGoOn = '重新匹配需要花费数十分钟时间，是否继续？';
          this.confirmGoOnFunction = e => {
            if (e.detail) {
              resolve();
            } else {
              reject();
            }
            window.removeEventListener('confirmGoOnEvent', this.confirmGoOnFunction);
          };
          window.addEventListener('confirmGoOnEvent', this.confirmGoOnFunction);
        })
          .then(() => {
            this.matchStatus = 0;
            autoMatch({
              id: this.detail.audioId
            }).then(res => {
              if (res.code === 200) {
                this.$message.success('正在后台进行自动匹配，请稍后刷新页面');
              }
            });
          })
          .catch(() => {
            //TODO
          });
      }
    },
    toTop(direction) {
      if (!this.log.logStatus) {
        if (+direction === 1) {
          this.audio.pause();
          this.playStatus = false;
          this.centerSentenceIndex = this.paragraphs[0].sentences[0].id;
          // this.audio.currentTime = 0
        } else if (+direction === -1) {
          this.audio.pause();
          this.playStatus = false;
          const plen = this.paragraphs.length;
          const slen = this.paragraphs[plen - 1].sentences.length;
          this.centerSentenceIndex = this.paragraphs[plen - 1].sentences[slen - 1].id;
          // this.audio.currentTime = this.audio.duration
        } else if (+direction === 0) {
          this.$nextTick(() => {
            this.centerSentenceIndex = this.playingIndex;
            if (this.$refs.activeRef && this.$refs.activeRef[0]) {
              this.$refs.activeRef[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
            }
          });
        }
      }
    },
    showLog() {
      if (this.detail.audioIdPath) {
        this.log.logStatus = !this.log.logStatus;
        this.log.logContent = '';
        if (this.log.logStatus) {
          audioLogQuery({
            audioId: this.detail.audioId
          }).then(res => {
            if (res.code === 200) {
              this.log.logList = res.data;
            }
          });
        }
      }
    },
    clickLogEdit(index, logItem) {
      this.log.logContent = logItem.content;
      this.log.editingIndex = index;
    },
    manageLog(type, logItem) {
      const body = {
        type: type
      };
      if (+type === 1) {
        body.content = this.log.logContent;
        body.audioId = this.detail.audioId;
      } else if (+type === 2) {
        body.audioLogId = logItem.id;
        body.content = this.log.logContent;
      } else if (+type === 3) {
        body.audioLogId = logItem.id;
      }

      if (!this.log.logContent.length && +type !== 3) {
        this.$message.error('请填写log内容');
      } else {
        audioLogManage(body)
          .then(res => {
            if (res.code === 200) {
              const message = +type === 3 ? '删除成功' : '保存成功';
              this.$message.success(message);
              this.log.logContent = '';
              return audioLogQuery({ audioId: this.detail.audioId });
            }
          })
          .then(res => {
            if (res.code === 200) {
              this.log.logList = res.data;
            }
          });
        this.log.editingIndex = -1;
      }
    }
  }
};
</script>
<style lang="less">
.times-container {
  .items {
    width: 50px;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
    .item {
      width: 50px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .item-active {
      color: rgb(24, 144, 247);
    }
  }
}
</style>
<style lang="less" scoped>
.container {
  background-color: #606f7b;
  text-align: center;
  padding: 50px 200px 20px 200px;
  height: 100vh;
  position: relative;
  .content {
    user-select: none;
    padding: 0 20px;
    background: #fff;
    position: relative;
    height: 100%;
    .log-btn {
      position: absolute;
      right: 0;
      top: -40px;
      width: 100px;
      height: 30px;
      background: #1890f7;
      border-radius: 6px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .log-disabled {
      color: #ffffff;
      background: #cdcdcd;
    }
    .title {
      height: 60px;
      border-bottom: 1px solid #cdcdcd;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        color: #000;
        font-size: 36px;
        font-weight: 900;
      }
      .logo {
        height: 80%;
      }
    }
    .detail {
      overflow: hidden;
      height: 100px;
      display: flex;
      flex-direction: column;
      .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .detail-item {
          margin: 4px 4px 0 0;
          min-width: 35%;
          display: flex;
          align-items: center;
          line-height: 22px;
          &:first-child {
            .label {
              text-align: left;
            }
            .content {
              text-align: left;
            }
          }
          .label {
            width: 80px;
            text-align: right;
            font-size: 16px;
            font-weight: normal;
          }
          .content {
            padding: 0;
            flex: 9;
            text-align: left;
            font-size: 16px;
            color: #000;
            font-weight: bold;
          }
        }
      }
    }
    .audio-container-wrap {
      margin: 20px 0 -20px 0;
      overflow-x: auto;
      overflow-y: none;
      min-height: 120px;
      .audio-container {
        width: 100%;
        min-width: 510px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #cccccc;
        .player {
          position: relative;
          background: #efefef;
          height: 100%;
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          min-width: 300px;
          padding-right: 50px;
          .btn-group {
            width: 80%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            .point-btn,
            .point-btn-inactive {
              margin: 0 20px;
              border-radius: 50%;
              border: 3px solid red;
              display: flex;
              align-items: center;
            }
            .point-btn-inactive {
              border-color: #cdcdcd;
            }
          }
          .play-hint {
            margin-top: 10px;
            width: 74%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            user-select: none;
          }
          .times-btn {
            cursor: pointer;
            background: #dedede;
            width: 50px;
            border-radius: 8px;
            position: absolute;
            right: 20px;
          }
        }
        .timeline {
          flex: 7;
          display: flex;
          justify-content: space-between;
          position: relative;
          padding: 0;
          height: 100%;
          cursor: pointer;
          .waveform,
          .waveform-active {
            position: absolute;
            transform: translateY(50%);
            top: 0;
            left: 0;
            width: 100%;
            height: 50%;
            z-index: 0;
          }
          .waveform {
            background: url('../../assets/image/common/waveform.png') repeat-x;
            background-position: 1px 0;
          }
          .waveform-active {
            background: url('../../assets/image/common/waveform-active.png') repeat-x;
            z-index: 1;
            overflow: hidden;
            background-position: 1px 0;
          }
          .flag-container {
            transform: translateY(-12px);
            position: absolute;
            width: 100%;
            flex: 1;
            display: flex;
          }
          .mark-large-container {
            transform: translate(-2px, 88px);
            flex: 1;
            display: flex;
            justify-content: space-around;
            height: 14px;
            .mark-large {
              height: 10px;
              width: 1px;
              background: #cdcdcd;
              span {
                position: absolute;
                transform: translate(-50%, 10px);
              }
            }
            .mark-small {
              height: 5px;
              width: 1px;
              background: #cdcdcd;
              transform: translateY(5px);
              display: flex;
            }
          }
        }
      }
    }
    .tag-container {
      margin-top: 20px;
      padding-top: 6px;
      width: 100%;
      height: 70px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      .tag-item {
        position: relative;
        padding: 4px;
        margin: 0 2% 6px 0;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #efefef;
        cursor: pointer;
        min-width: 8%;
        max-width: 8%;
        .close-btn {
          position: absolute;
          right: -4px;
          top: -6px;
        }
      }
      .tag-item-active {
        // border: 1px solid rgb(24, 144, 247);
        // color: rgb(24, 144, 247);
        background: rgb(24, 144, 247);
        color: white;
      }
    }
    .text-container {
      height: calc(100% - 380px);
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 28px;
      .audio-text,
      .summary-text {
        cursor: pointer;
        padding: 10px;
        overflow: scroll;
        text-align: left;
      }
      .paragraph-des {
        text-indent: 30px;
        color: #ababab;
      }
      .paragraph {
        text-indent: 30px;
        text-align: left;
        width: fit-content;
        .sentence {
          display: inline;
          .sentence-content {
            display: inline;
            cursor: pointer;
          }
          .sentence-content-editing {
            margin-right: 10px;
            border: 1px dashed green;
          }
        }
      }
      .playing {
        color: red;
      }
    }
    .text-container-edit {
      background: rgb(240, 240, 240);
    }
    .text-container-half {
      min-width: 50%;
      margin-right: 4px;
    }
    .noaudio,
    .waitingconvert {
      text-align: left;
      margin-top: 30px;
      // height: calc(100% - 360px);
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      line-height: 28px;
      padding: 50px 0;
      position: relative;
      .convert-background {
        position: absolute;
        top: 30px;
        right: 0;
        left: 0;
        bottom: 0;
        text-align: center;
        img {
          height: 35vh;
        }
      }
    }
    .log-container {
      height: calc(100% - 360px);
      margin-top: 40px;
      font-size: 14px;
      line-height: 28px;
      .save-btn {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        width: 60px;
        border-radius: 4px;
        float: right;
        background: rgb(24, 144, 247);
        color: white;
      }
      .log-list {
        clear: both;
        height: calc(100% - 120px);
        overflow: scroll;
        .log-item {
          margin-top: 60px;
          padding-bottom: 10px;
          padding: 0 16px 12px 16px;
          border-bottom: 1px solid #cdcdcd;
          .description {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .headimg {
              height: 30px;
              display: flex;
              align-items: center;
              img {
                height: 100%;
              }
              .nickname {
                margin-left: 10px;
              }
            }
            .updatetime {
            }
          }
          .log-content {
            text-align: left;
            padding: 0;
          }
          .log-operation {
            text-align: right;
            .log-save {
              padding: 0 6px;
              margin-right: 10px;
              border-radius: 4px;
              background: rgb(24, 144, 247);
              color: white;
            }
          }
        }
      }
    }
    .menu {
      position: absolute;
      right: -180px;
      top: 180px;
      bottom: 0;
      width: 150px;
      cursor: pointer;
      user-select: none;
      .operation {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        height: 30px;
        width: 80%;
        border-radius: 10px;
        background: white;
        font-size: 16px;
      }
      .operation-disabled {
        color: #ffffff;
        background: #cdcdcd;
      }
      .audio-menu {
        margin-top: 20px;
      }
      .text-menu {
        margin-top: 120px;
      }
    }
    .play-menu {
      position: absolute;
      left: -120px;
      top: 380px;
      bottom: 0;
      width: 100px;
      cursor: pointer;
      user-select: none;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .operation {
        font-size: 40px;
      }
    }
  }
}
</style>
